import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('Container')(
  css({
    position: 'sticky',
    bottom: 0,
    width: '100%',
    left: 0,
    paddingX: '20px',
    pt: ['s', 's', '20px'],
    pb: ['m', 'm', '20px'],
    boxShadow: '2px -2px 8px 0px #70707026',
    backgroundColor: 'white',
    zIndex: 3,
  }),
);

themeStyles.addBaseStyles('Wrapper')(
  css({
    backgroundColor: 'white',
    display: 'flex',
    p: 0,
    flexDirection: ['column', 'column', 'row'],
    gap: ['s', 's', 'default'],
    justifyContent: 'space-between',
    alignItems: 'center',
  }),
);

themeStyles.addBaseStyles('Finance')(({ isFetching }) =>
  css({
    display: isFetching ? 'none' : 'block',
  }),
);

themeStyles.addBaseStyles('PriceSection')(({ isError }) =>
  css({
    display: 'flex',
    gap: isError ? '0' : '20px',
    flexGrow: 1,
    justifyContent: 'space-between',
    backgroundColor: 'white',
    pt: ['xxs', 'xxs', 'zero'],
    '[data-testid="loading"]': {
      margin: 0,
    },
    width: ['100%', '100%', 'auto'],
    pl: ['0', '0', '36px'],
  }),
);

themeStyles.addBaseStyles('InventoryDetails')(
  css({
    display: 'grid',
    width: ['100%', '100%', 'auto'],
    alignItems: 'start',
    gap: '10px 30px',
    '& > :nth-child(1)': {
      gridColumn: '1',
    },
    '& > :nth-child(2)': {
      gridColumn: '2',
    },
  }),
);

themeStyles.addBaseStyles('Price')(
  css({
    display: 'flex',
    alignItems: 'start',
    flexShrink: 0,
  }),
);

themeStyles.addBaseStyles('CtaSection')(({ isResponsive }) =>
  css({
    display: 'grid',
    gridTemplateColumns: ['1fr', '1fr', isResponsive ? '1fr 1fr' : '1fr'],
    gap: ['m', 'm', '20px'],
    backgroundColor: 'white',
    width: ['100%', '100%', isResponsive ? 'auto' : '460px'],
  }),
);

themeStyles.addBaseStyles('IconWrapper')(
  css({
    display: 'flex',
  }),
);

themeStyles.addBaseStyles('CtaButton')(({ styling }) =>
  css({
    width: '100%',
    display: 'flex',
    whiteSpace: 'nowrap',
    justifyContent: ['center'],
    gap: ['m'],
    alignItems: ['center'],
    '& > div > div': {
      backgroundColor: styling === 'secondary' ? 'secondary' : 'white',
    },
    '&:hover > div > div': {
      backgroundColor: 'white',
    },
  }),
);

export default themeStyles;
